import React, { useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import AppSidebar from '../../../components/AppSidebar';
import AppHeader from '../../../components/AppHeader';
import PageHeader from '../../../components/PageHeader';
import DesignationService from '../../../services/DesignationService';
import DepartmentService from '../../../services/DepartmentService';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';

const EditDesignation = () => {
    const { id } = useParams();
    const { register, handleSubmit, control, reset, formState: { errors } } = useForm();
    const [loading, setLoading] = useState(false);
    const [departmentList, setDepartmentList] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {

        const fetchDepartment = async () => {
            try {
                const response = await DepartmentService.listAll();
                const departmentList = response?.data?.data;
                const formattedDepartmentList = departmentList?.map((department) => ({
                    value: department.id,
                    label: department.name,
                }));
                setDepartmentList(formattedDepartmentList);
            } catch (err) {
                toast.error('Failed to load departments');
            }
        };

        const fetchData = async () => {
            try {
                const Response = await DesignationService.get(id);
                const designationData = Response.data.data;

                if (designationData) {
                    const department = {
                        value: designationData?.department?.id,
                        label: designationData?.department?.name,
                    };

                    reset({
                        ...designationData,
                        department,
                    });
                } else {
                    toast.error('Designation data is empty or undefined');
                }
            } catch (error) {
                console.error('Error fetching data', error);
                toast.error('Error fetching data');
            }
        };

        fetchDepartment();
        fetchData();

    }, [id,reset]);

    const onSubmit = async (data) => {
        setLoading(true);
        const requestBody = {
            data: {
                ...data,
                department_id: data?.department ? data?.department?.value : null,
            }
        };
        try {
            const response = await DesignationService.update(id, requestBody);
            if (response.status === 200) {
                toast.success(response?.data?.message);
                setTimeout(() => {
                    navigate('/designations');
                }, 500);
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-12">
                            <PageHeader title='Edit Designation' button_label1="Back"
                                link_to1="/designations" className1="btn btn-primary btn-sm" />
                            <div className="card p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        {/* Designation Name */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Name</label>
                                                <input
                                                    type="text"
                                                    {...register('name', {
                                                        required: 'Name is required',
                                                        minLength: { value: 3, message: 'Name must be at least 3 characters' }
                                                    })}
                                                    className={`form-control ${errors?.name ? 'is-invalid' : ''}`}
                                                />
                                                {errors?.name && <div className="invalid-feedback">{errors?.name?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Department List*/}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Department</label>
                                                <Controller
                                                    name="department"
                                                    control={control}
                                                    rules={{ required: "Department field is required" }}
                                                    defaultValue=""
                                                    render={({ field }) => (
                                                        <Select
                                                            {...field}
                                                            options={departmentList}
                                                            closeMenuOnSelect={true}
                                                            isClearable={true}
                                                        />
                                                    )}
                                                />
                                                {errors?.department && <div className="invalid-feedback d-block">{errors?.department?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Description Box */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    {...register('description', {
                                                        maxLength: { value: 255, message: 'Description must be at least 255 characters' }
                                                    })}
                                                    className={`form-control ${errors?.description ? 'is-invalid' : ''}`}
                                                    rows="4"
                                                />
                                                {errors?.description && <div className="invalid-feedback">{errors?.description?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Status*/}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group pb-4">
                                                <label className="mb-1 form-label">Status</label>
                                                <select
                                                    {...register('status', {
                                                        required: 'Status is required'
                                                    })}
                                                    className={`form-select ${errors?.status ? 'is-invalid' : ''}`}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="active">Active</option>
                                                    <option value="inactive">Inactive</option>
                                                </select>
                                                {errors?.status && <div className="invalid-feedback">{errors?.status?.message}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" className="btn btn-primary" disabled={loading}>
                                        {loading ? 'Saving...' : 'Save'}
                                    </button>
                                </form>
                                <ToastContainer />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditDesignation;